/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar15(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M16.8 10.8 15.6 12H14v.9l-.3 2.7-.2.9-.4 3.5h-2.2l-.4-3.5-.2-.8-.3-2.8V12H8.4l-1.2-1.2.2-.4 3.6.6 1-1 1 1 3.6-.6zM16 7H8c0-2.1 2.1-3 4-3s4 .9 4 3z" opacity=".3"/><path d="M11 11h2v2h-2z"/><path d="m18.6 10.1.4-.1V7h-1c0-2.9-2.5-5-6-5S6 4.1 6 7H5v3l.4.1-.6 1.1L7.6 14h.5l1 8h5.8l1-8h.5l2.8-2.8-.6-1.1zM12 4c1.9 0 4 .9 4 3H8c0-2.1 2.1-3 4-3zm3.6 8H14v.9l-.3 2.7-.2.9-.4 3.5h-2.2l-.4-3.5-.2-.8-.3-2.8V12H8.4l-1.2-1.2.2-.4 3.6.6 1-1 1 1 3.6-.6.2.4-1.2 1.2z"/><path d="M9 15h6v2H9z"/></svg>
  );
}

export default Avatar_icn_avatar15;
